import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { EmployeesHead } from "../Employees/EmployeesHead";
import { EmployeesTable } from "../Employees/EmployeesTable";

export function Employees() {
  return (
    <Container>
      <Row>
        <Col>
          <EmployeesHead />
        </Col>
      </Row>
      <Row>
        <Col>
          <EmployeesTable />
        </Col>
      </Row>
    </Container>
  );
}
